import {
  COUNTRY_LEVEL_CUISINE_FRAGMENT,
  CITY_LEVEL_CUISINE_FRAGMENT,
  RESTAURANT_REVIEWS_FRAGMENT,
  RECOMMENDED_CUISINES_FRAGMENT,
  CUISINE_NEIGHBORHOODS_FRAGMENT,
  CUISINE_CITIES_FRAGMENT,
  CUISINE_ALTERNATE_LOCALE_FRAGMENT,
} from './fragments';

export function getCountryLevelPage({ cuisine, locale, country }) {
  return {
    query: `
      query cuisineDetails($country: String!, $cuisineSlug: String!, $locale: String!) {
        cuisine(country: $country, cuisineSlug: $cuisineSlug, locale: $locale) { ...cuisineDetails }
        restaurant_reviews(country: $country, cuisineSlug: $cuisineSlug, locale: $locale) { ...restaurantReviews }
        recommended_cuisines(country: $country, cuisineSlug: $cuisineSlug, locale: $locale) { ...recommendedCuisines }
        cities(cuisineSlug: $cuisineSlug, country: $country, locale: $locale) { ...cuisineCities }
        alternate_locale_cuisines(cuisineSlug: $cuisineSlug, country: $country, locale: $locale) { ...cuisineAlternateLocale }
      }
${COUNTRY_LEVEL_CUISINE_FRAGMENT}
${RESTAURANT_REVIEWS_FRAGMENT}
${RECOMMENDED_CUISINES_FRAGMENT}
${CUISINE_CITIES_FRAGMENT}
${CUISINE_ALTERNATE_LOCALE_FRAGMENT}
    `,
    variables: {
      cuisineSlug: cuisine,
      locale,
      country,
    },
  };
}

export function getCityLevelPage({ cuisine, locale, country, city }) {
  return {
    query: `
      query cuisineDetails($country: String!, $cuisineSlug: String!, $locale: String!, $citySlug: String) {
        cuisine(country: $country, cuisineSlug: $cuisineSlug, locale: $locale, citySlug: $citySlug) { ...cuisineDetails }
        restaurant_reviews(country: $country, cuisineSlug: $cuisineSlug, locale: $locale, citySlug: $citySlug) { ...restaurantReviews }
        recommended_cuisines(country: $country, cuisineSlug: $cuisineSlug, locale: $locale, citySlug: $citySlug) { ...recommendedCuisines }
        cities(cuisineSlug: $cuisineSlug, country: $country, locale: $locale) { ...cuisineCities }
        neighborhoods(citySlug: $citySlug) { ...cuisineNeighborhoods }
        alternate_locale_cuisines(cuisineSlug: $cuisineSlug, country: $country, locale: $locale, citySlug: $citySlug) { ...cuisineAlternateLocale }
      }
${CITY_LEVEL_CUISINE_FRAGMENT}
${RESTAURANT_REVIEWS_FRAGMENT}
${RECOMMENDED_CUISINES_FRAGMENT}
${CUISINE_CITIES_FRAGMENT}
${CUISINE_NEIGHBORHOODS_FRAGMENT}
${CUISINE_ALTERNATE_LOCALE_FRAGMENT}
    `,
    variables: {
      cuisineSlug: cuisine,
      locale,
      country,
      citySlug: city,
    },
  };
}

export function getAllCuisines({ locale, country }) {
  return {
    query: `
      query cuisines($country: String!, $locale: String!) {
        cuisines(country: $country, locale: $locale) {
          title
          description
          image
          url
        }
      }
    `,
    variables: {
      locale,
      country,
    },
  };
}
